import { TypeOf, yup } from '@guiker/yup-util'

export const findOneContractQueryParamsSchema = yup.object({
  scopeType: yup.string().required(),
  scopeId: yup.string().required(),
  locale: yup.string().nullable().default('en'),
})

export type FindOneContractQueryParams = TypeOf<typeof findOneContractQueryParamsSchema>
